var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLibra(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9960",
    "data-name": "Group 9960",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 189.998,
    height: 179,
    viewBox: "0 0 189.998 179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5352",
    "data-name": "Rectangle 5352",
    width: 189.998,
    height: 179,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9792",
    "data-name": "Group 9792",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27838",
    "data-name": "Path 27838",
    d: "M37.246,368.082c.045-1.1,1.017-1.65,1.508-2.486a17.127,17.127,0,0,0,1.272-15.059c-.84-2.335-.11-2.505,1.772-2.326a4.655,4.655,0,0,0,1.043-.135,2.4,2.4,0,0,1,1.933-.73,74.2,74.2,0,0,1,10.637.212,24.546,24.546,0,0,0,3.4.157c10.938.011,21.877.081,32.813-.044a5.872,5.872,0,0,1,6.092,3.869,15.738,15.738,0,0,1-.719,15.413,5.44,5.44,0,0,1-5.06,2.859c-5.188.106-10.353-.345-15.53-.431-5.254-.088-10.514-.117-15.767,0-6.963.161-13.9-.674-20.856-.476a2.87,2.87,0,0,1-2.535-.827",
    transform: "translate(-21.357 -199.726)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27839",
    "data-name": "Path 27839",
    d: "M33.207,363.606l45.578.683c3.408.051,6.818.042,10.223.175a2.682,2.682,0,0,0,2.6-1.372c4.587-6.732,3.178-12.656.109-18.152-.624-1.117-1.592-.754-2.436-.759-10.012-.056-20.026-.021-30.037-.119-6.814-.066-13.626-.3-20.438-.463-1.24-.1-2.478-.215-3.719-.294-.944-.06-1.941-.215-2.169-1.241-.259-1.162.822-1.43,1.636-1.794,3.425-.49,6.868-.141,10.3-.2a31.733,31.733,0,0,0,7.5-.593c4.237.324,8.479.139,12.717.05a24.575,24.575,0,0,1,2.947.089c1.605.032,3.211.011,4.817.015,3.245.452,6.527.037,9.776.413,3.458-.19,6.919-.285,10.379-.362a2.034,2.034,0,0,1,.706.208c5.317,5.865,7.229,14,3.453,21.1-1.619,3.044-3.114,6.207-6.439,7.886-2.312.566-4.426-.7-6.732-.643-6.6.158-13.216.271-19.81.005-9.935-.4-19.868-.314-29.8-.4-1.334-.011-2.745.035-3.65-1.271-1.033-2.087-.66-2.53,2.49-2.965",
    transform: "translate(-17.317 -195.25)",
    fill: "#480e02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27840",
    "data-name": "Path 27840",
    d: "M186.7,161.829c-1.428-9.834.356-19.379,2.584-28.89.432-1.845.733-3.721,1.094-5.582,2.538-1.25,4.961-.375,7.39.4,2.324,11.151,5.32,22.228,3.787,33.808a5.782,5.782,0,0,1-.405,2.468c-.314-.053-.267-.939-.975-.178-4.019,4.323-10.622,3.293-13.475-2.021",
    transform: "translate(-106.762 -72.888)",
    fill: "#671405"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27841",
    "data-name": "Path 27841",
    d: "M121.994,254.007c1.72-1.885,4.082-2.61,6.358-3.492.745-1.2,2.006-1.5,3.242-1.817a70.1,70.1,0,0,1,18.5-2.282c6.8.086,13.607-.408,20.391.407a67.474,67.474,0,0,1,12.683,2.586,4.276,4.276,0,0,1,2.741,1.844c2.713,1.115,5.281,2.4,6.46,5.353.18.363.236.7-.2.933-9.128.573-18.244-.255-27.366-.348-5.631-.058-11.3-.52-16.939-.954-7.453-.574-14.923-.833-22.391-1.139a16,16,0,0,0-2.528.284c-1.157.133-1.4-.387-.953-1.375",
    transform: "translate(-69.83 -141.685)",
    fill: "#490f02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27842",
    "data-name": "Path 27842",
    d: "M13.4,403.249a25.5,25.5,0,0,0,5.059.4c16.6.187,33.2.414,49.8.561,1.921.017,3.656,1.278,5.624.67a7.513,7.513,0,0,1,4.716-.651c1.81.243,3.63.3,5.445.445,4.75.4,9.489,1.066,14.276.582.944.082,1.662.55,1.684,1.513.026,1.128,1,2.016.706,3.188-12.492.362-24.973-.434-37.465-.35-8.581.057-17.168-.168-25.745-.458q-12.954-.437-25.892-1.291a63.074,63.074,0,0,1-10.109-1.2c-.6-.138-1.5-.08-1.5-.847s.9-.738,1.5-.866a87.238,87.238,0,0,1,9.676-1.224c.756-.075,1.584.17,2.223-.467",
    transform: "translate(0 -231.928)",
    fill: "#77191a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27843",
    "data-name": "Path 27843",
    d: "M341.731,240.412c3.82.33,6.492,2.52,8.538,5.5.691,1.006,1.316,1.7,2.551,1.7a11.658,11.658,0,0,1-1.111,4.782c-2.29,6.438-6.68,11.381-11.555,15.962-.924.868-1.945,1.734-3.4,1.066-5.484-.7-8.352-4.551-10.826-8.885-.238-.7.248-1.042.709-1.365,6.19-4.343,10.247-10.36,13.479-17.023.365-.752.563-1.631,1.616-1.737",
    transform: "translate(-186.85 -138.273)",
    fill: "#671405"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27844",
    "data-name": "Path 27844",
    d: "M293.263,238.628a5.964,5.964,0,0,1-1.02-6.138,32.393,32.393,0,0,1,14.642-18.275c3-1.764,4.945-1.29,7.169,1.1a5.82,5.82,0,0,1,.123,4.331,31.729,31.729,0,0,1-12.539,17.031c-1.371.7-2.8,1.289-4.127,2.065-1.437.837-2.863,1.143-4.248-.11",
    transform: "translate(-167.336 -122.594)",
    fill: "#b61b15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27845",
    "data-name": "Path 27845",
    d: "M370.086,260.3q3.268,3,6.538,6.006a2.148,2.148,0,0,1,.729,2.1c-1.716,8.423-5.5,15.5-13.21,20a6.8,6.8,0,0,1-1.185.427c-1.861.672-3.251-.233-4.578-1.355-.588-.5-1.229-.932-1.767-1.484a2.973,2.973,0,0,0-1.8-1.359,4.068,4.068,0,0,1-1.875-.883c-.145-.826.535-1.1,1.037-1.431,8.012-5.259,12.8-12.844,15.837-21.7a.735.735,0,0,1,.27-.319",
    transform: "translate(-202.365 -149.71)",
    fill: "#671405"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27846",
    "data-name": "Path 27846",
    d: "M319.4,403.416c3.089.843,6.3.757,9.439,1.2a9.761,9.761,0,0,1,3.885,1.222c-2.745,1.555-5.532,1.5-8.186,1.716-8.956.726-17.925,1.2-26.913,1.472-4.387.133-8.786.043-13.163.337-11.528.774-23.083,0-34.611.644a2.4,2.4,0,0,1-.8-.259c-.436-.86.282-1.408.559-2.079.793-1,1.466-2.154,2.912-2.359a59.113,59.113,0,0,1,10.463-.057,6.677,6.677,0,0,0,3.348.227c3.02-.374,6.066-.255,9.084-.6,1.694-.178,3.392-.385,5,.432a38.7,38.7,0,0,0,8.477.111,113.736,113.736,0,0,1,17.828,0c3.461.271,6.947.014,10.418.1,1.624.042,1.587-1.332,2.26-2.111",
    transform: "translate(-142.729 -232.024)",
    fill: "#77191a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27847",
    "data-name": "Path 27847",
    d: "M58.358,300.992c-5.987.316-11.977.19-17.965.1.638-.67,1.466-.4,2.214-.4,3.756-.023,7.515-.076,11.268.029,1.791.05,2.269-.345,1.444-2.078a30.367,30.367,0,0,1-3.028-15.806,48.249,48.249,0,0,1,1.985-9.495c.459-1.567,1.71-1.958,3.144-1.973,2.126-.023,4.252,0,6.378.007a2.37,2.37,0,0,1,.065,1.873c-.18.376-.345.779-.893.665-1.712-.516-3.469-.039-4.836-.215,1.248.038,2.859-.077,4.468.046a1.5,1.5,0,0,1,.5.341,1.434,1.434,0,0,1,.158.6,8.2,8.2,0,0,1-.367,1.543,7.677,7.677,0,0,0-.282.946c-1.693,6.123-2.21,12.235.083,18.339a4.105,4.105,0,0,1,.313,1.654c-.756,2.58-2.909,1.186-4.2,1.569,1.555.26,3.439-.406,5.207.421.99,1.638.978,1.654-.8,1.721a35.926,35.926,0,0,0-4.862.124",
    transform: "translate(-23.161 -156.068)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27848",
    "data-name": "Path 27848",
    d: "M315.356,370.842l-4.677-.229c-.84-1.464.231-2.547.783-3.707a22.063,22.063,0,0,0,1.76-15.041,7.738,7.738,0,0,0-1.58-3.437,2.887,2.887,0,0,1-.423-3.333c.4-.831.184-2.041,1.429-2.369.083.388-.035.886.527,1.017.2.048.421.033.631.06,2.2.293,4.923-.755,6.5,1.052a21.3,21.3,0,0,1,4.443,9.478,16.562,16.562,0,0,1,.338,5.461c-.118,1.086.239,1.588,1.334,1.554.035.227-.053.521-.229.525-2.555.05-4.276,2.02-6.519,2.785a3.9,3.9,0,0,0-2.856,3.579c-.277.988-.143,2.206-1.468,2.606",
    transform: "translate(-177.965 -197.118)",
    fill: "#b61b15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27849",
    "data-name": "Path 27849",
    d: "M308.652,239.106a32.71,32.71,0,0,0,12.318-16.972c.417-1.317-.258-2.658.39-3.9l6.172,5.053a8.9,8.9,0,0,1-1.048,5.912c-3.084,6.06-6.642,11.782-12.168,15.985-1.372,1.044-2.779,2.181-4.676,2.187-1.025-1.655-2.8-2.518-4.126-3.855-1.354-1.365-1.286-2,.441-2.771a14.177,14.177,0,0,0,2.7-1.64",
    transform: "translate(-174.641 -125.518)",
    fill: "#671405"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27850",
    "data-name": "Path 27850",
    d: "M61.236,134.778a5.074,5.074,0,0,1,.739-3.241c.3-.5.564-1.067,1.254-.913.807.18.6.876.487,1.389-.226,1.01.11,1.414,1.151,1.48,8.6.546,17.2,1.13,25.8,1.684a5.729,5.729,0,0,0,2.522-.207c.763-.3,1.4-.218,1.654.71a8.163,8.163,0,0,1-4.514,5.069,25.368,25.368,0,0,1-23.86.387,10.215,10.215,0,0,1-4.265-3.7c-.528-.812-.453-1.844-.971-2.661",
    transform: "translate(-35.095 -75.114)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27851",
    "data-name": "Path 27851",
    d: "M264.637,113.224c-.874-1.1.071-2.152.1-3.228a.556.556,0,0,1,.8-.46c2.948,1.414,6.15.678,9.208.961,6.109.565,12.245.938,18.369,1.412,2.641.2,2.65.085,2.239-2.528l-.026.024c1.279.714,2.674,1.317,2.922,3.02a11.088,11.088,0,0,1-5.857,5.552,27.443,27.443,0,0,1-20.087.955,14.786,14.786,0,0,1-7.667-5.709",
    transform: "translate(-151.531 -62.911)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27852",
    "data-name": "Path 27852",
    d: "M144.024,26.731c-4.227.552-8.488.4-12.732.586-6.87.3-13.748.417-20.623.611-1.186-1.074-.654-3.189-2.4-3.923a.683.683,0,0,1-.223-.512c11.1-1.476,22.19-2.976,33.336-4.043a3.994,3.994,0,0,1,1.061,2.414,11.927,11.927,0,0,0,1.581,4.866",
    transform: "translate(-61.953 -11.187)",
    fill: "#671405"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27853",
    "data-name": "Path 27853",
    d: "M358.727,390.525c2.169.414,3.164,1.931,3.689,3.891-.53,1.729-2.088,1.769-3.445,1.932a49.546,49.546,0,0,1-10.992.531c-5.649-.583-11.3-.261-16.951-.363a21.016,21.016,0,0,1-4.21-.445,2.455,2.455,0,0,1-1.913-1.161,3.46,3.46,0,0,1,2.28-3.481,18.462,18.462,0,0,1,6.3-1.71c6.867-.572,13.75.146,20.611-.38a6.742,6.742,0,0,1,4.632,1.188",
    transform: "translate(-186.291 -223.911)",
    fill: "#661405"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27854",
    "data-name": "Path 27854",
    d: "M171.176,231.649a111.978,111.978,0,0,1,13.4,2.441,27.467,27.467,0,0,1,8.169,3.535,4.522,4.522,0,0,1,2.035,2.365c-.784,1.085-1.8.648-2.691.3-7.927-3.137-16.26-3.949-24.635-3.684-9.192.291-18.4.916-27.3,3.663-.659.2-1.336.542-2.049.144.547-2.293,2.511-3.157,4.324-4.055,5.491-2.719,11.465-3.621,17.463-4.4.628-.081,1.248-.221,1.872-.334,3.136.255,6.272-.11,9.408.024",
    transform: "translate(-79.191 -133.215)",
    fill: "#b51c15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27855",
    "data-name": "Path 27855",
    d: "M220.077,11.031q8.874-1.046,17.749-2.089c3.311-.384,6.625-.741,9.937-1.111.508,1.475-.067,3.174.945,4.545-6.954,1.722-14.044,2.766-21.052,4.218-2.772.574-5.565,1.054-8.348,1.578.181-1.433,1.476-2.435,1.442-4a5.026,5.026,0,0,0-.674-3.141",
    transform: "translate(-125.751 -4.505)",
    fill: "#671405"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27856",
    "data-name": "Path 27856",
    d: "M239.127,271.27q.074-.388.149-.775c.4,2.522,2.057,2.376,3.9,1.819,2.168.139,3.366,1.786,4.747,3.1.6.57.315,1.147-.419,1.481a11.268,11.268,0,0,1-4.844.256c-4.8-.594-9.607-.35-14.409-.335-6.436.02-12.848-.52-19.276-.613a15.992,15.992,0,0,0-3.723-.529c-1.6-.083-2.062-.829-1.342-2.182.376-.707.5-1.568,1.153-2.13,7.355.042,14.7-.283,22.063.252,3.979.289,8.022.554,12-.348",
    transform: "translate(-116.736 -155.575)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27857",
    "data-name": "Path 27857",
    d: "M137.576,246.033A29.208,29.208,0,0,1,147.64,243.2a136.509,136.509,0,0,1,21.465-1.794c8.189.126,16.262,1.069,23.923,4.213.462.189.815,0,1.218,0,.788.822.265,1.875.5,2.794a55.647,55.647,0,0,0-15.211-3.605c-7.991-.911-16.024-.543-24.028-.365a58.857,58.857,0,0,0-18.322,3.231c.08-.558-.055-1.167.4-1.636",
    transform: "translate(-78.659 -138.838)",
    fill: "#a21611"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27858",
    "data-name": "Path 27858",
    d: "M185.965,96.8c-2.915-4.224-1.855-9.015,2.551-11.542.428-.246.844-.513,1.266-.771a5.886,5.886,0,0,1,6.419.517l2.166,2.372c1.415,2.56.334,4.973-1.071,6.878-2.3,3.112-8.2,4.6-11.331,2.545",
    transform: "translate(-105.695 -48.185)",
    fill: "#b61c16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27859",
    "data-name": "Path 27859",
    d: "M189.929,267.752c.241,1.148-.444,1.294-1.345,1.272q-16.54-.386-33.079-.757a1.84,1.84,0,0,1-1.716.605c-2.562-.438-5.176-.068-7.732-.534a9.524,9.524,0,0,0-3.337-.554c-6.948-.017-13.892-.371-20.842-.252-.862.015-1.681.248-2.529.312-1.052-.1-1.985-.291-1.363-1.71.56-.6.869-1.439,1.717-1.756.573-.009-.457,1.249.644.814,3.026-1.2,6.164-.4,9.2-.252,2.394.12,4.8.209,7.2.261,2.118.047,4.182.528,6.268.682a29.3,29.3,0,0,0,4.481.123,56.816,56.816,0,0,1,10.546.433c6.107.642,12.2-.117,18.227.577,4.2.484,8.324.14,12.48.074.663-.01.84.364,1.188.662",
    transform: "translate(-67.538 -152.057)",
    fill: "#3a0c05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27860",
    "data-name": "Path 27860",
    d: "M299.943,332.327l-.694,2.355a5.638,5.638,0,0,1-4.244,3.032c-1.392.166-2.186,1.475-3.489,1.81a.638.638,0,0,1-.514-.245c1.4-2.947-1.283-4.075-2.621-5.8a1.851,1.851,0,0,1-.169-.9,19.13,19.13,0,0,1,.645-2.69,7.109,7.109,0,0,1,1.931-3.519,9.635,9.635,0,0,1,2.406-1.4,3.128,3.128,0,0,1,.6-.168,6.984,6.984,0,0,1,2.44-.073,19.183,19.183,0,0,1,3.822,3.352q.053.14.1.283c-.357,1.3.372,2.668-.212,3.961",
    transform: "translate(-165.259 -186.719)",
    fill: "#671505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27861",
    "data-name": "Path 27861",
    d: "M323.336,401.715a16.686,16.686,0,0,0,5.173.865c2.687.017,5.379.107,8.06-.019,4.528-.212,9.009.582,13.531.466a83.287,83.287,0,0,0,8.814-.829,4,4,0,0,0,1.879-.871l.549.887c.792,2.9.792,2.908-2.2,2.876-8.426-.089-16.852-.24-25.278-.26-3.11-.007-6.22.313-9.333.424-.866.031-1.889.353-2.472-.708q.44-1.4.882-2.8c.116-.227.248-.227.395-.028",
    transform: "translate(-184.669 -230.823)",
    fill: "#490e02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27862",
    "data-name": "Path 27862",
    d: "M189.334,8.8a10.781,10.781,0,0,1,2.3-5.324A4.886,4.886,0,0,1,198.183,2.4c2.592,4.178,2.056,8.117-1.547,11.372a5.373,5.373,0,0,1-6.472.871c-1.705-2.135-1.953-3.894-.831-5.842",
    transform: "translate(-108.172 -0.916)",
    fill: "#b51c16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27863",
    "data-name": "Path 27863",
    d: "M199.434,218.84c-3.139,1.034-6.277,1.456-9.409-.025-1.363-3.021-2.662-6.061-2.635-9.467,1.229.362,1.636,1.664,2.681,2.278,3.571,2.1,7.032,3.48,11.6-1.966.065.735.117,1.311.168,1.886-.157,2.643-1.319,4.956-2.406,7.294",
    transform: "translate(-107.449 -120.406)",
    fill: "#490f03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27864",
    "data-name": "Path 27864",
    d: "M314.167,253.971c5.034-1.994,8.544-5.7,11.515-10.053a67.705,67.705,0,0,0,5.358-8.985c.754-1.581.094-3.39,1.194-4.8,1.458.732,2.543,1.62,1.63,3.48a.732.732,0,0,0,.36.89c-1.86,3.187-3.139,6.667-5.414,9.663-2.982,3.925-5.967,7.773-10.34,10.278a2.017,2.017,0,0,1-1.2,1.469c-2.637,1.226-3.7.887-4.5-1.437.317-.574.73-.885,1.394-.5",
    transform: "translate(-179.344 -132.358)",
    fill: "#490f02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27865",
    "data-name": "Path 27865",
    d: "M365.562,258.609c.413,2.116-.868,3.737-1.656,5.485-2.3,5.107-5.166,9.817-9.511,13.52A49.191,49.191,0,0,1,348.483,282a1,1,0,0,1-.9.918c-1.568-.411-2.893-1.017-2.467-3.036a2.071,2.071,0,0,1,.8-.829c.714-.153,1.352-.73,2.156-.4,1.55.9,2.37-.639,2.926-1.305,2.653-3.176,6.138-5.613,8.1-9.423a45.925,45.925,0,0,0,3.695-8.223,9.816,9.816,0,0,1,1.021-2.341c.657.314,1.495.376,1.752,1.248",
    transform: "translate(-197.841 -148.021)",
    fill: "#490f02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27866",
    "data-name": "Path 27866",
    d: "M265.134,117.345c.152-.634.4-.664.775-.139,3.443,4.851,8.562,6.162,14.083,6.493a26.16,26.16,0,0,0,10.837-1.463,14.775,14.775,0,0,0,7.058-5.157,1.151,1.151,0,0,1,.859-.532c.412,1.784-.662,3.016-1.751,4.093-4.75,4.7-10.742,5.77-17.1,5.421a20.112,20.112,0,0,1-10.276-3.112c-2.064-1.38-3.98-2.952-4.487-5.6",
    transform: "translate(-152.028 -67.032)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27867",
    "data-name": "Path 27867",
    d: "M63.348,143.763c2.57,3.608,6.429,4.988,10.512,5.786a24.98,24.98,0,0,0,16.692-2.329c2.151-1.111,3.589-2.933,5.142-4.662.442,2.034-.732,3.385-2.069,4.585-4.633,4.158-10.282,5.234-16.248,4.921a20.621,20.621,0,0,1-11.241-3.474,8.135,8.135,0,0,1-3.191-3.6c-.25-.533-.581-1.093.4-1.224",
    transform: "translate(-35.943 -81.992)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27868",
    "data-name": "Path 27868",
    d: "M324.522,392.524q-.2.018-.395.028a4.359,4.359,0,0,1,3-3.9,8.077,8.077,0,0,0,3.434-2.009c.941-1.117,2.561-.172,3.753-.783a170.661,170.661,0,0,1,17.849-.458,7.253,7.253,0,0,1,6.125,2.842,18.143,18.143,0,0,0-4-.386c-7.867-.1-15.728.1-23.586.449-3.323.148-5.119,1.367-6.185,4.215",
    transform: "translate(-185.854 -221.632)",
    fill: "#9f1813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27869",
    "data-name": "Path 27869",
    d: "M192.82,15.384a6.8,6.8,0,0,0,8.517-6.092c.137-1.585.345-3.255-.847-4.648a.792.792,0,0,1-.044-1.145c2.23.925,2.68,3.09,3.5,4.995.919,1.094.517,2.408.613,3.639a4.1,4.1,0,0,1-1.864,3.76c-.963,1.154-2.173,2.188-1.943,3.928a14.529,14.529,0,0,0-3.457-.441,2.714,2.714,0,0,1-2.586-1.061l-.947-.784c-.568-.606-1.631-1-.945-2.151",
    transform: "translate(-110.435 -2.012)",
    fill: "#a11712"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27870",
    "data-name": "Path 27870",
    d: "M203.363,45.879a78.519,78.519,0,0,1,.15,8.934c-1.846,1.415-3.851.348-5.787.367a1.249,1.249,0,0,1-.542-.455q.08-4.032.16-8.064c1.883-1.2,3.838-1.859,6.019-.783",
    transform: "translate(-113.065 -26.075)",
    fill: "#671505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27871",
    "data-name": "Path 27871",
    d: "M188.164,101.676c1.719-.023,3.417.195,5.161.048a7.667,7.667,0,0,0,5.9-3.3,8.365,8.365,0,0,0,1.34-6.17,7.465,7.465,0,0,1-.6,10.313,3.6,3.6,0,0,0-1.283,2.731c-1.647.008-3.294.057-4.941.041a2.476,2.476,0,0,1-2.078-.725c-1.249-.883-2.766-1.449-3.5-2.937",
    transform: "translate(-107.893 -53.059)",
    fill: "#a11712"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27872",
    "data-name": "Path 27872",
    d: "M115.888,268.513c-.128,1.05.471,1.238,1.333,1.117,4.438-.274,8.881-.032,13.319-.13,1.483-.033,1.624.761,1.34,1.905a2.651,2.651,0,0,1-.589,1.4,1.069,1.069,0,0,1-.988.42,1.961,1.961,0,0,1-.626-.368,4.344,4.344,0,0,0-2.453-.387c-3.295-.01-6.589.008-9.884-.011a3.938,3.938,0,0,1-2.24-.386c-1.19-.782-.628-2.106-.973-3.153l1.76-.409",
    transform: "translate(-65.441 -154.435)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27873",
    "data-name": "Path 27873",
    d: "M317.516,312.392a46.644,46.644,0,0,1-5.116,6.373l-.113-.114c-.059-2.047-2.267-2.855-2.723-4.676,1.2-2.5,2.637-4.792,5.293-6.023,1.461,1.138,1.314,3.232,2.659,4.441",
    transform: "translate(-177.503 -177.118)",
    fill: "#681607"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27874",
    "data-name": "Path 27874",
    d: "M290.379,3.1c2.2-3.141,3.69-3.727,6.4-2.519-.058.34-.6.4-.308,1.01,1.007,2.125.292,3.884-1.447,5.323-.863.308-1.142,1.357-2.049,1.611a.815.815,0,0,1-.561-.155l-.86-.866c-2.034-1.59-2.25-2.4-1.173-4.4",
    transform: "translate(-166.137 0)",
    fill: "#b21f1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27875",
    "data-name": "Path 27875",
    d: "M196.657,67.653l5.932-.011c.978.391,1.975.743,2.929,1.185.7.326,1.4.733,1.342,1.692a7.182,7.182,0,0,1-4.511,1.6c-1.459.078-2.92-.419-4.4.208a1.879,1.879,0,0,1-2.076-.763.931.931,0,0,1-.13-.6c.087-.109-.294-.9-.181-.98.61-.427-.577.638-.485-.319.084-.868.5-.392,0-.955-.31-.483,1.157-.867,1.58-1.054",
    transform: "translate(-112.142 -38.904)",
    fill: "#b31d17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27876",
    "data-name": "Path 27876",
    d: "M98.052,26.955l.1.148a5.333,5.333,0,0,1,.339,4.389l-2.978,1.974a1.033,1.033,0,0,1-.749.41,1.7,1.7,0,0,1-.57-.093,1.774,1.774,0,0,0-1.815-.088.809.809,0,0,1-.546-.116l-.972-1.031c-.665-1.086.167-1.412.922-1.611,2.012-.529,2.645-1.823,2.481-3.792-.117-1.405-.01-1.414,1.221-1.678,1.051.161,1.481,1.387,2.568,1.487",
    transform: "translate(-51.96 -14.648)",
    fill: "#9f1813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27877",
    "data-name": "Path 27877",
    d: "M93.368,24.647c-.886.211-.741.831-.64,1.489.443,2.889-.164,3.906-2.958,4.695-.58.164-1.1.108-1.025.9-1.835-1.617-2.357-4.083-1.213-5.733a4.316,4.316,0,0,1,5.836-1.347",
    transform: "translate(-49.844 -13.827)",
    fill: "#b31e18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27878",
    "data-name": "Path 27878",
    d: "M324.583,307.66c-1.584.078-1.6-1.262-1.987-2.226-.279-.693-.446-1.43-.663-2.148-.3-1.8.967-2.653,2.153-3.56,2-.05,3.122,1.219,4.108,2.7a1.036,1.036,0,0,1-.17.922c-.821.77-1.035,2.015-2.067,2.62a6.208,6.208,0,0,0-1.383,1.7Z",
    transform: "translate(-184.57 -172.386)",
    fill: "#4a1005"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27879",
    "data-name": "Path 27879",
    d: "M301.012,7.358c2.147-2.268,2.328-4.239.286-5.379l1.889-.6c3.481,1.93,3.46,5.343-.05,8.113a1.166,1.166,0,0,1-.794.407c-1.452-.32-1.563-1.34-1.331-2.538",
    transform: "translate(-172.546 -0.791)",
    fill: "#a11a14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27880",
    "data-name": "Path 27880",
    d: "M196.169,120.87c1.9-.019,3.825.347,5.69-.279.949-.319.991.5,1.329.965q.108,1.31.215,2.624c-.123.307-.285.929-.558.722-2.1-1.591-4.557-.771-6.832-1.117l.155-2.914",
    transform: "translate(-112.394 -69.317)",
    fill: "#4c0f04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27881",
    "data-name": "Path 27881",
    d: "M304.084,275.384l-1.348.527c-1,.468-1.492-.237-2.023-.86a1.718,1.718,0,0,1-.147-.585l-4.863-3.956-.515-.7c3.259,1.035,5.374-1.678,8.083-2.446-.5,1.055-1.544,1.4-2.486,1.857-1.107.539-1.727,1.037-.3,2,1.1.744,2.053,1.713,3.154,2.461.734.5.982.958.445,1.707",
    transform: "translate(-169.261 -153.772)",
    fill: "#9c1914"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27882",
    "data-name": "Path 27882",
    d: "M190.964,73.042a3.661,3.661,0,0,0,3.165.635c2.628-.4,5.338-.241,7.9-1.134.164,1.415-.991,1.654-1.906,2.025a16.2,16.2,0,0,1-2.191.563,6.962,6.962,0,0,1-6.681-.421c-1.592-.508-3.682-.234-4.1-2.587,2.255-1.5,3.152-1.286,3.817.918",
    transform: "translate(-107.31 -40.928)",
    fill: "#a41b14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27883",
    "data-name": "Path 27883",
    d: "M351,316.248l.9-.918a3.28,3.28,0,0,1,2.116.428c.61.371,1.118.879,1.714,1.269,1.9,1.39,3.467,3.378,6.12,3.446a4.626,4.626,0,0,1-6.143-.4c-1.54-1.311-3.139-2.554-4.711-3.827",
    transform: "translate(-201.265 -181.354)",
    fill: "#a01814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27884",
    "data-name": "Path 27884",
    d: "M203.576,41.881a42.837,42.837,0,0,0-6.019.783q0-2.14,0-4.28c1.478.353,3.008.823,4.478.339,1.332-.439,1.316.425,1.565,1.165l-.022,1.994",
    transform: "translate(-113.278 -22.076)",
    fill: "#50160a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27885",
    "data-name": "Path 27885",
    d: "M102.677,269.476c1.494.562,1.021,1.542.542,2.524a.515.515,0,0,1-.1.543c-3.021.452-6.031.722-8.942-.564a2.987,2.987,0,0,1,.455-1.689c2.64-.695,5.4-.219,8.05-.814",
    transform: "translate(-53.991 -154.989)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27886",
    "data-name": "Path 27886",
    d: "M189.146,24.048q.472,1.076.945,2.151l-1.258.022a1.546,1.546,0,0,1-1.682-1.288c-.349-1.993-.645-3.994-.962-5.992l1.734-.377c-.024,1.924-.107,3.86,1.223,5.484",
    transform: "translate(-106.761 -10.677)",
    fill: "#4d1003"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27887",
    "data-name": "Path 27887",
    d: "M216.274,22.716a10.613,10.613,0,0,0,1.234-3.495c.574-1.224-.124-2.587.417-3.816l.412-.043c1.209.051,1.662.421,1.424,1.836-.334,1.979-.015,4.117-2.192,5.306l-1.293.212",
    transform: "translate(-124.011 -8.835)",
    fill: "#4d1104"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27888",
    "data-name": "Path 27888",
    d: "M287.628,7.3a5.9,5.9,0,0,0,1.174,4.4l-2.459.365c-1.823-.4-1.416-1.842-1.217-2.967.09-.51-.081-1.108.272-1.578l2.231-.224",
    transform: "translate(-163.385 -4.2)",
    fill: "#4b1106"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27889",
    "data-name": "Path 27889",
    d: "M239.789,410.467l-.906,1.679c-1.8,1.487-3.657,1.784-5.617.305a4.639,4.639,0,0,1-1.28-3.192c.06-.6-.251-.892-.808-.987.061-.842.633-.71,1.184-.619,1.452,3.613,4.085,4.142,7.428,2.815",
    transform: "translate(-132.557 -234.422)",
    fill: "#823328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27890",
    "data-name": "Path 27890",
    d: "M196.764,79.518l6.68.42a.369.369,0,0,1-.14.381,10.9,10.9,0,0,1-2.907.456c.891.1,1.9-.454,2.9,0a3.113,3.113,0,0,1,.031,1.778,23.111,23.111,0,0,0-6.419-.516q-.074-1.261-.148-2.522",
    transform: "translate(-112.824 -45.735)",
    fill: "#5e1006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27891",
    "data-name": "Path 27891",
    d: "M286.87,35.924a.973.973,0,0,1,.183-1.318c1.465-.649,1.657-1.639,1.163-3.017a.866.866,0,0,1,.593-1.013c1.146-.393,1.182-1,.514-1.882a.679.679,0,0,1,.289-1.062,1.506,1.506,0,0,1,1.6,0,.777.777,0,0,1,.216,1.12c-1.117,1.027-.886,2.575-1.588,3.744l-.1-.105q-.053-.054.107.1c-1.363.817-.353,2.452-1.2,3.448a1.435,1.435,0,0,0-1.04.2.893.893,0,0,1-.739-.212",
    transform: "translate(-164.39 -15.758)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27892",
    "data-name": "Path 27892",
    d: "M108.41,33.706a8.544,8.544,0,0,1-.34-4.389c3.026.153,1.941,2.707,2.525,4.286l-2.186.1",
    transform: "translate(-61.88 -16.862)",
    fill: "#4b1003"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27893",
    "data-name": "Path 27893",
    d: "M324.713,77.4c-.518-.963-.326-2.2-1.168-3.037,1.023-1.159-.692-1.906-.446-2.948,1.7-.1,2.608,1.008,1.991,2.649-.428,1.139-.373,1.631.916,2.146,1.769.707.668,1.871.067,2.849a.265.265,0,0,1-.431.018l-.413-.441c0-.483.36-1.116-.515-1.237",
    transform: "translate(-185.251 -41.069)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27894",
    "data-name": "Path 27894",
    d: "M272.011,85.56l-.937,2.219c-.534.417-1.121.822-.379,1.549l-.759,2.2a1.654,1.654,0,0,1-1.748-.432,7.546,7.546,0,0,0,1.061-2.247A33.962,33.962,0,0,0,271,83.569c.029-.093.39-.087.6-.126.426.65-.266,1.518.417,2.117",
    transform: "translate(-153.779 -47.992)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27895",
    "data-name": "Path 27895",
    d: "M190.964,70.9c-1.03-1.307-2.419-1.131-3.817-.918.511-2.376,2.753-1.866,4.281-2.544a1.2,1.2,0,0,1,.4.1l-.382.842a4.7,4.7,0,0,1-.436,2.449Z",
    transform: "translate(-107.31 -38.787)",
    fill: "#b1241f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27896",
    "data-name": "Path 27896",
    d: "M306.925,32.441c-.951-.386-.888-1.425-1.249-2.187-.188-.4.13-.69.524-.675,1.155.044,1.419,1,1.648,1.842.14.511-.316.869-.924,1.02",
    transform: "translate(-175.243 -17.012)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27897",
    "data-name": "Path 27897",
    d: "M118.763,97.481c-.874-.483-.962-1.382-1.147-2.149-.163-.679.447-.462.843-.472,1.085-.027,1.235.852,1.392,1.55.166.742-.765.627-1.089,1.071",
    transform: "translate(-67.426 -54.544)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27898",
    "data-name": "Path 27898",
    d: "M298.675,15.453c.653.594.2,1.894,1.387,2.149a.529.529,0,0,1-.17.541.7.7,0,0,1-.84-.153L298.28,18c-.9.462-1.319.082-1.437-.819.742-.439.6-1.8,1.832-1.73",
    transform: "translate(-170.209 -8.886)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27899",
    "data-name": "Path 27899",
    d: "M315.746,54.658c-.918-.208-.947-1.091-1.235-1.733-.195-.433.025-.838.593-.8a1.391,1.391,0,0,1,1.456,1.209c.133.709-.307,1-.814,1.324",
    transform: "translate(-180.3 -29.978)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27900",
    "data-name": "Path 27900",
    d: "M74.526,99.54c.609.02.971.28.834.78-.19.7-.083,1.673-1.033,1.869a.764.764,0,0,1-.892-.91c.151-.7.171-1.589,1.092-1.738",
    transform: "translate(-42.096 -57.25)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27901",
    "data-name": "Path 27901",
    d: "M330.624,92.4l.856-.047c1.249.668,1.5,1.511.458,2.581-1.7.23-1.148-1.36-1.689-2.068.073-.2.086-.441.375-.466",
    transform: "translate(-189.364 -53.117)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27902",
    "data-name": "Path 27902",
    d: "M204.346,81.861a10.14,10.14,0,0,1-5.757-.031c2.244-.686,4.029-.3,5.762-.428q0,.229,0,.459",
    transform: "translate(-113.871 -46.818)",
    fill: "#440f01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27903",
    "data-name": "Path 27903",
    d: "M295.915,19.529a1.91,1.91,0,0,0,1.436.82c-.036.951-.37,2.109-1.374,1.778-.756-.249-1.026-1.538-.42-2.521l.358-.076",
    transform: "translate(-169.281 -11.232)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27904",
    "data-name": "Path 27904",
    d: "M70.744,113.21c-.532-.145-1.014-.407-.918-.97.112-.651.182-1.445,1.035-1.644.484-.113.859.135.816.652a2.31,2.31,0,0,1-.934,1.962",
    transform: "translate(-40.031 -63.594)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27905",
    "data-name": "Path 27905",
    d: "M87.731,62.6c.461.051.666.326.506.718-.3.724-.14,1.8-1.2,1.967-.371.057-.695-.5-.6-.962.16-.761.371-1.531,1.3-1.723",
    transform: "translate(-49.552 -36.005)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27906",
    "data-name": "Path 27906",
    d: "M279.489,73.729c-.409.486-.014,1.62-1.071,1.669-.459.021-.792-.517-.665-1.089.157-.7.41-1.367,1.279-1.389.449-.011.521.354.457.81",
    transform: "translate(-159.248 -41.94)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27907",
    "data-name": "Path 27907",
    d: "M125.632,115.919c-.033-.136-.073-.271-.1-.41-.111-.626-.875-1.35.058-1.85,1.077-.577,1.2.587,1.676,1.084-.217.846-.375,1.772-1.636,1.175",
    transform: "translate(-71.752 -65.281)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27908",
    "data-name": "Path 27908",
    d: "M283.091,62.906c-.339.554-.087,1.623-1.155,1.659-.408.013-.7-.5-.619-.945.133-.777.4-1.538,1.38-1.54.469,0,.48.4.393.827",
    transform: "translate(-161.3 -35.705)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27909",
    "data-name": "Path 27909",
    d: "M79.146,90.658c-.259.664-.2,1.481-1.077,1.444-.587-.025-.761-.519-.741-1.063.026-.728.555-.891,1.129-1,.607-.109.686.257.689.613",
    transform: "translate(-44.339 -51.778)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27910",
    "data-name": "Path 27910",
    d: "M322.669,71.422c1.519,1.147,1.637,1.928.446,2.948.071-1.016-1.451-1.792-.446-2.948",
    transform: "translate(-184.821 -41.078)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27911",
    "data-name": "Path 27911",
    d: "M335.593,105.839a4.244,4.244,0,0,1-1.147-2.617c1.9.183,1.9.183,1.12,2.641l.026-.024",
    transform: "translate(-191.771 -59.368)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27912",
    "data-name": "Path 27912",
    d: "M107.944,68.167c.612.081,1.127.372,1.067,1.033-.042.459-.44,1.033-.913.956-.74-.121-.751-.91-.829-1.5-.055-.417.235-.614.675-.484",
    transform: "translate(-61.504 -39.183)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27913",
    "data-name": "Path 27913",
    d: "M336.2,306.25q-.026-.408-.053-.815c.2-.412.652-.793.96-.624,1.215.667,2.778.669,3.7,1.89l-.788.447a8.374,8.374,0,0,0-3.818-.9",
    transform: "translate(-192.747 -175.288)",
    fill: "#991f18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27914",
    "data-name": "Path 27914",
    d: "M110.112,76.826c1.066.291,2.019.155,1.985,1.241-.009.3-.552.86-.781.827-1.008-.147-.7-1.147-1.2-2.068",
    transform: "translate(-63.138 -44.186)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27915",
    "data-name": "Path 27915",
    d: "M82.947,73.365c2.1-.315,1.734.831,1.229,2.059-1.925.211-1.5-.967-1.229-2.059",
    transform: "translate(-47.424 -42.166)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27916",
    "data-name": "Path 27916",
    d: "M126.3,117.6c.857.039,1.128-.732,1.636-1.175.629.953-.593,1.92.023,2.872l-.114.226a.584.584,0,0,1-.7-.072L126.3,117.6",
    transform: "translate(-72.421 -66.961)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27917",
    "data-name": "Path 27917",
    d: "M285.969,47.451h.754a1.036,1.036,0,0,1,.932.356c.107.878-.86,1.351-.835,2.2a1.153,1.153,0,0,1-1.7-.032c.685-.707,1.635-1.326.847-2.524",
    transform: "translate(-163.489 -27.285)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27918",
    "data-name": "Path 27918",
    d: "M67.032,121.581c1.066-.091,1.336.107,1.243.53-.124.568-.076,1.348-.944,1.358a.693.693,0,0,1-.695-.843,2.45,2.45,0,0,1,.4-1.045",
    transform: "translate(-38.204 -69.914)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27919",
    "data-name": "Path 27919",
    d: "M311.954,43.933c-1.382.735-1.037-.663-1.294-1.14s-.929-1.339.393-1.531a2.113,2.113,0,0,1,.9,2.671",
    transform: "translate(-177.902 -23.732)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27920",
    "data-name": "Path 27920",
    d: "M104.913,59.67c.474.068.834.311.792.807a.908.908,0,0,1-.953.927c-.448-.047-.572-.565-.6-1-.038-.537.235-.771.764-.732",
    transform: "translate(-59.717 -34.317)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27921",
    "data-name": "Path 27921",
    d: "M275.6,85.56c-1.947-.353-.946-1.281-.417-2.118,1.64.413.592,1.351.417,2.118",
    transform: "translate(-157.372 -47.992)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27922",
    "data-name": "Path 27922",
    d: "M115.274,88.3c-.584-.195-.57-.745-.683-1.176-.143-.544.22-.732.705-.7s.807.276.733.781c-.067.461-.185.949-.756,1.094",
    transform: "translate(-65.688 -49.704)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27923",
    "data-name": "Path 27923",
    d: "M268.164,101.44c.617,0,1.27-.138,1.747.431-.072.537-.008,1.271-.821,1.167-.881-.112-1-.842-.926-1.6",
    transform: "translate(-153.755 -58.336)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27924",
    "data-name": "Path 27924",
    d: "M313.021,43.934l-.9-2.671c1.537.39,1.9,1.476.9,2.671",
    transform: "translate(-178.969 -23.732)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27925",
    "data-name": "Path 27925",
    d: "M82.665,73.437c-.01.935-.167,1.957,1.229,2.06.09.764-.561,1.184-.835,1.78a.269.269,0,0,1-.424-.052c.336-1.26-1.122-2.534.03-3.788",
    transform: "translate(-47.141 -42.237)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27926",
    "data-name": "Path 27926",
    d: "M102.3,52.122a1.123,1.123,0,0,1-.761.9c-.553.182-.7-.311-.829-.683-.173-.493,0-.8.578-.769.418.026.837.07,1.012.551",
    transform: "translate(-57.712 -29.659)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27927",
    "data-name": "Path 27927",
    d: "M91.371,55.665a1.02,1.02,0,0,1-.754-1.006c-.011-.523.457-.65.855-.724.444-.081.626.2.552.614a1.484,1.484,0,0,1-.654,1.116",
    transform: "translate(-51.959 -31.013)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27928",
    "data-name": "Path 27928",
    d: "M93.173,44.3a2.735,2.735,0,0,0,.388-.142.683.683,0,0,1,.554.028.97.97,0,0,1,.518.663,2.177,2.177,0,0,1-.266,1.1c-1.785.445-1.479-.611-1.194-1.651",
    transform: "translate(-53.3 -25.374)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27929",
    "data-name": "Path 27929",
    d: "M122.764,107.02a.662.662,0,0,1-.554-.777c.019-.536.388-.7.856-.718.406-.012.718.182.7.6-.02.614-.549.741-1.007.9",
    transform: "translate(-70.075 -60.692)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27930",
    "data-name": "Path 27930",
    d: "M320.056,62.145c.971-.486,1.235.228,1.444.9.28.9-.565.934-1.047,1.24a2.686,2.686,0,0,1-.4-2.137",
    transform: "translate(-183.472 -35.65)",
    fill: "#88b6b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27931",
    "data-name": "Path 27931",
    d: "M132.873,132.066c.412.157,1.064.088.927.807-.073.383-.254.89-.736.844-.564-.053-.629-.65-.752-1.083-.116-.414.109-.635.561-.568",
    transform: "translate(-75.85 -75.951)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27932",
    "data-name": "Path 27932",
    d: "M62.5,142.542c-.454.3-.4.773-.4,1.224a4.158,4.158,0,0,1-.862-3.331c.93.4.811,1.423,1.264,2.106",
    transform: "translate(-35.095 -80.772)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27933",
    "data-name": "Path 27933",
    d: "M96.265,46.057q.01-.609.02-1.218c.39-.784,1.181-.1,1.687-.458l.779-.088c-.222,1.436-1.594,1.264-2.486,1.763",
    transform: "translate(-55.198 -25.476)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27934",
    "data-name": "Path 27934",
    d: "M326.916,84.547c.158-.332.218-1.013.764-.558.736.615.678,1.312-.248,1.795-.467-.29-.407-.8-.515-1.237",
    transform: "translate(-187.453 -48.219)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27935",
    "data-name": "Path 27935",
    d: "M272.638,95.132c-.646-.017-1.2-.257-1.029-.982.165-.681.817-.665,1.408-.567l-.379,1.549",
    transform: "translate(-155.722 -53.796)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27936",
    "data-name": "Path 27936",
    d: "M284.626,53.405l1.7.031c.01.459.054.93-.463,1.185-.436-.173-.569.179-.757.435-.842-.354-1.156-.86-.478-1.651",
    transform: "translate(-162.993 -30.716)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27937",
    "data-name": "Path 27937",
    d: "M130.051,123.186c.811.1,1.582.333,1.17,1.361-.13.324-.275,1.692-1.215.5.18-.546-.27-1.122.077-1.66Z",
    transform: "translate(-74.512 -70.85)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27938",
    "data-name": "Path 27938",
    d: "M81.258,82.148l.424.052q.179,1.469-1.293,1.266c-.4-.307-.773-.662-.461-1.2.2-.338.568-.325.91-.147a2.265,2.265,0,0,0,.419.026",
    transform: "translate(-45.764 -47.161)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27939",
    "data-name": "Path 27939",
    d: "M333.592,94.661a2,2,0,0,0-.457-2.581c1-.629,1,.374,1.14.8.229.694.395,1.515-.683,1.778",
    transform: "translate(-191.019 -52.844)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27940",
    "data-name": "Path 27940",
    d: "M302.022,21.343l.889-.063a.884.884,0,0,1,.492,1.394c-1.462.587-.987-.82-1.382-1.331",
    transform: "translate(-173.179 -12.239)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27941",
    "data-name": "Path 27941",
    d: "M304.6,22.209l-.492-1.394a3.3,3.3,0,0,1,.12-.325l.739-.018c.282.664.866,1.391-.367,1.738",
    transform: "translate(-174.375 -11.774)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27942",
    "data-name": "Path 27942",
    d: "M219.583,15.317c-.166,1.269.429,2.62-.417,3.816q.009-1.952.018-3.9a.4.4,0,0,1,.4.089",
    transform: "translate(-125.67 -8.747)",
    fill: "#671405"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27943",
    "data-name": "Path 27943",
    d: "M289.709,46.327a1.034,1.034,0,0,1-.931-.356c-.059-.468-.27-1.095.477-1.105s.442.7.547,1.117a1.052,1.052,0,0,0-.093.345",
    transform: "translate(-165.543 -25.804)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27944",
    "data-name": "Path 27944",
    d: "M319.406,62.362a3.377,3.377,0,0,1,.4,2.137c-1.164-1-1.246-1.435-.4-2.137",
    transform: "translate(-182.822 -35.867)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27945",
    "data-name": "Path 27945",
    d: "M129.124,123.591c.3.568.685,1.14-.076,1.66-.26-.566-.84-.989-.767-1.7l.843.044",
    transform: "translate(-73.552 -71.058)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27946",
    "data-name": "Path 27946",
    d: "M329.83,90.711l-.375.466a1.484,1.484,0,0,1-.493-1.742l.431-.018c.461.326.436.815.437,1.295",
    transform: "translate(-188.571 -51.428)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27947",
    "data-name": "Path 27947",
    d: "M80.537,81.874c-.976.174-.7.762-.449,1.345-.692-.138-.959-.589-.71-1.207s.721-.512,1.16-.137",
    transform: "translate(-45.462 -46.913)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27948",
    "data-name": "Path 27948",
    d: "M328.186,316.121a1.752,1.752,0,0,1,1.383-1.7,3.2,3.2,0,0,1-1.383,1.7",
    transform: "translate(-188.181 -180.839)",
    fill: "#681607"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27949",
    "data-name": "Path 27949",
    d: "M286.21,55.912c.038-.373-.216-.9.363-1.012.322-.063.362.311.394.577l-.757.434",
    transform: "translate(-164.099 -31.572)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27950",
    "data-name": "Path 27950",
    d: "M49.936,366.943a3.1,3.1,0,0,1,2.515-.662q21.512,0,43.024.022a7.693,7.693,0,0,1,.851.009c.52.059,1.352-.165,1.307.643-.043.757-.866.565-1.392.565-12.566.009-25.134.115-37.7-.089a65.15,65.15,0,0,1-8.607-.489",
    transform: "translate(-28.633 -210.653)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27951",
    "data-name": "Path 27951",
    d: "M95.548,385.871c-15.839.509-31.665.1-47.482-.854,15.841-.7,31.657.3,47.482.854",
    transform: "translate(-27.561 -221.305)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27952",
    "data-name": "Path 27952",
    d: "M86.32,374.34c-11.428.208-22.87.883-34.281-.4,11.437-.924,22.853.216,34.281.4",
    transform: "translate(-29.839 -214.863)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27953",
    "data-name": "Path 27953",
    d: "M48.09,357.761a187.189,187.189,0,0,1,27.426.525,174,174,0,0,1-27.426-.525",
    transform: "translate(-27.575 -205.588)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27954",
    "data-name": "Path 27954",
    d: "M183.453,368.714l-10.269-.382a26.568,26.568,0,0,0,6.434-10.275c1.829-5.557.346-10.514-2.551-15.262-.473-.775-.92-1.565-1.378-2.348a1.218,1.218,0,0,1,1.03-.646c2.862.081,5.749-.433,8.583.33,3.206,3.462,4.518,7.582,4.87,12.263.444,5.911-1.925,10.668-5.225,15.206a2.8,2.8,0,0,1-1.493,1.114",
    transform: "translate(-99.304 -195.381)",
    fill: "#b61b15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27955",
    "data-name": "Path 27955",
    d: "M86.692,300.979c-2.955-6.863-2.686-13.793-.429-20.764,1.267-.7,1.924-.112,2.3,1.071-1.087,2.544-.836,3.01,2.058,3.123,1.02.039,2.416.674,2.94-1-.407,1.1-1.308,1.082-2.238,1.054-.991-.029-2.084.039-2.8-.672-1-.985.493-1.708.5-2.629a1.682,1.682,0,0,1,1.378-.7,8.092,8.092,0,0,1,1.668-.066c1.589.314,2.343-.484,2.671-1.9,1.223-1.221,1.6-.343,1.892.752a38.736,38.736,0,0,1-.838,6.473,31.121,31.121,0,0,0,1.919,15.334,15.194,15.194,0,0,1,.672,2.376,2.077,2.077,0,0,1,.124.571,1.145,1.145,0,0,1-.306.787L82.5,304.756c1.635-.569,3.32-.178,4.979-.246s.865-.72.4-1.34a.445.445,0,0,1,.025-.539c1.482-.458,2.839.755,4.347.3.651-.194,1.436.02,1.883-.706.985-1.278-.088-1.6-.95-1.788a25.628,25.628,0,0,0-3.317-.151c-1.273-.112-.456,1.063-.883,1.481-.4.529-1.081.406-1.6.661-.868-.183-.309-1.04-.692-1.453",
    transform: "translate(-47.307 -159.832)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27956",
    "data-name": "Path 27956",
    d: "M133.467,338.669a72.323,72.323,0,0,1-9.787-.328c-.915-.514-1.907-.162-2.861-.242-.688-.057-1.428.111-1.869-.637l-.015.018c-.394-.841.131-1.122.808-1.269a5.955,5.955,0,0,1,2.061-.087c2.65.558,5.333.153,8,.28,1.042.05,2.122-.169,3.1.408a1.906,1.906,0,0,1,.744.825.943.943,0,0,1-.175,1.032",
    transform: "translate(-68.12 -193.292)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27957",
    "data-name": "Path 27957",
    d: "M153.178,338.046q0-.392,0-.784c.076-1.654,1.267-1.837,2.542-1.912,2.119-.124,4.25.228,6.36-.158a1.759,1.759,0,0,1,.555-.2c.706.089.866.687,1.126,1.2a1.517,1.517,0,0,1,.046,1.353,39.437,39.437,0,0,1-10.626.508",
    transform: "translate(-87.831 -192.669)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27958",
    "data-name": "Path 27958",
    d: "M177.5,338.016l-.437-1.089c.436-1.521,1.67-.951,2.58-.857a23.789,23.789,0,0,0,6.738-.077,2.734,2.734,0,0,1,1.292-.136,1.505,1.505,0,0,1,.625,2.158,1.272,1.272,0,0,1-.482.377l-9.9-.18-.412-.2",
    transform: "translate(-101.529 -193.146)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27959",
    "data-name": "Path 27959",
    d: "M119.153,339.344c1.453.951,3.3-.189,4.73.879a19,19,0,0,1-4.659-.1l-.07-.779",
    transform: "translate(-68.322 -195.173)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27960",
    "data-name": "Path 27960",
    d: "M197.255,367.971c2.173-3.272,4.8-6.473,5.611-10.273a20.787,20.787,0,0,0-1.19-13.277,9.547,9.547,0,0,0-2.17-3.405c-.469-.4-.183-.748-.113-1.133a2.394,2.394,0,0,1-.016-.265,4.432,4.432,0,0,1,2.87-1.187c2.412,0,4.825-.049,7.237.023a6.166,6.166,0,0,1,3.41,1.037c1.926,1.091,2.387,3.011,2.924,4.95.981,3.542,1.919,7.046,1.786,10.8a16.772,16.772,0,0,1-1.769,7.322,3.059,3.059,0,0,0-.387,2.212,3.835,3.835,0,0,1-2.433,3.371c-.465-.018-.948-.1-1.289.342a41.967,41.967,0,0,1-14.471-.517",
    transform: "translate(-113.106 -194.638)",
    fill: "#a01612"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27961",
    "data-name": "Path 27961",
    d: "M333.228,296.659c-1.672.011-2.888-1.642-4.659-1.266-1.262-.837-2.231-2.085-3.707-2.622a4.207,4.207,0,0,1-1.818-4.558l1.251-.886c1.048-.138,1.291.629,1.549,1.373,1.041,2.994,3.789,4.413,5.965,6.343.988.877,2.557-.194,3.585.836-.695.335-1.283.964-2.166.78",
    transform: "translate(-185.168 -165.247)",
    fill: "#9e1611"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27968",
    "data-name": "Path 27968",
    d: "M359.8,317.626a2.176,2.176,0,0,1-1.714-1.269,2.008,2.008,0,0,1,1.714,1.269",
    transform: "translate(-205.325 -181.952)",
    fill: "#7a150a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27969",
    "data-name": "Path 27969",
    d: "M281.731,352.995a7.837,7.837,0,0,1,5-2.651c1.348-.109,2-1.432,3.057-2.074-.755,1.241-.23,2.052.531,3.228,2.417,3.742,2.294,7.977,1.8,12.253-.422,3.658-2.491,6.672-3.608,10.05a88.206,88.206,0,0,1-11.2.794c-.366.017-.749-.326-1.124-.5-.331-.878.144-1.653.344-2.451.989-3.949,2.094-7.878,1.883-12.542-1.648,1.834-2.713,3.611-4.152,5.052-.626.628-1.076,1.554-2.223,1.3-.657-.619-.178-1.218.147-1.687a114.175,114.175,0,0,1,8.4-10.307,1.348,1.348,0,0,1,1.139-.469",
    transform: "translate(-155.8 -200.307)",
    fill: "#a01612"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27970",
    "data-name": "Path 27970",
    d: "M260.22,353.319c-3.3,4.074-6.935,7.882-9.828,12.28a.837.837,0,0,1-.073.987c-2.1,2.7-3.973,5.6-6.7,7.759l-2.1,2.332c-1.186.673-2.209,1.736-3.734,1.615-2.063-.164-3.121-1.4-3.589-4.153.4-1.334,1.789-2.063,2.123-3.437.084-1.8,1.548-2.77,2.554-3.928,4.574-5.258,9.218-10.459,14.069-15.471.921-.612,1.3-1.769,2.323-2.285a1.487,1.487,0,0,1,1.175-.1c1.575,1.159,2.106,3.208,3.718,4.339Z",
    transform: "translate(-134.289 -200.631)",
    fill: "#671405"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27971",
    "data-name": "Path 27971",
    d: "M256.279,386.648c1.821-3.251,4.688-5.7,6.774-8.745,1.936-1.011,3-2.869,4.221-4.52.793-1.074,1.712-1.947,2.778-3.158a19.2,19.2,0,0,1-.231,7.817c-.613,2.941-.937,5.993-2.483,8.679l-11.06-.073",
    transform: "translate(-146.95 -212.935)",
    fill: "#b51c15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27972",
    "data-name": "Path 27972",
    d: "M102.176,277.913c-.08-.359.09-.879-.382-1.006-.455-.122-.411.386-.546.65a2.086,2.086,0,0,1-1.649.059c-1.348-.769-2.851.023-4.232-.409a.676.676,0,0,1-.145-.941c-.529.527-.018,1.6-1.043,1.757-.706-.187-.514-.986-.939-1.366-.016-.15-.032-.3-.048-.452l0-.01.421-.827,8.884.392a1.1,1.1,0,0,1,.572.876c-.039.606-.015,1.259-.9,1.278",
    transform: "translate(-53.436 -158.378)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27973",
    "data-name": "Path 27973",
    d: "M83.385,276.135c-2.13.862-4.348.292-6.524.39a.668.668,0,0,1-.772-.568.755.755,0,0,1,.5-.549c2.179-.083,4.369-.4,6.527.166.13.034.183.361.272.551l0,.01",
    transform: "translate(-43.63 -158.307)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27974",
    "data-name": "Path 27974",
    d: "M84.042,332.228l.813,1.309a.732.732,0,0,1,.391.438c-.006.148-.011.3-.016.443-2.441-.267-5,.477-7.349-.8,1.389-.747,2.86-.395,4.281-.5.745-.055,1.639.217,1.88-.889",
    transform: "translate(-44.657 -191.081)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27975",
    "data-name": "Path 27975",
    d: "M92.165,278.4c.83.068.77.726.857,1.286.67.864,2.29.2,2.616,1.618-.549.059-1.121.068-1.437.644a.68.68,0,0,1-.79-.158,2.041,2.041,0,0,0-2.1-1.286l.249-.456a1.127,1.127,0,0,0,.484-1.294.741.741,0,0,1,.116-.355",
    transform: "translate(-52.361 -160.123)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27976",
    "data-name": "Path 27976",
    d: "M92.384,279.237c.817.793.133,1.031-.483,1.294a2.008,2.008,0,0,1,.483-1.294",
    transform: "translate(-52.696 -160.603)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27981",
    "data-name": "Path 27981",
    d: "M237.2,302.034a13.574,13.574,0,0,0-1.895,3.351,2.754,2.754,0,0,1-2.527.78c-3.638-.434-7.306-.238-10.947-.569a13.05,13.05,0,0,0-3.782-.445q-9.044.035-18.089,0c-3.025-.009-3.594-.5-4.573-3.373a24.058,24.058,0,0,1,0-16.2c1.264-3.575,1.6-3.782,5.31-3.762a6.125,6.125,0,0,1,2.316.15l39.521.792a.193.193,0,0,1,.13.155,1.663,1.663,0,0,1,.023,1.969,22.061,22.061,0,0,0-2.4,13.847,2.141,2.141,0,0,1-.588,1.94.4.4,0,0,1-.369.1c-6.3.472-12.582-.329-17.605-.116,3.528.006,8.327.119,13.125.275.9.03,2.082-.358,2.347,1.1",
    transform: "translate(-111.232 -162.069)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27982",
    "data-name": "Path 27982",
    d: "M189.37,276.418c-.566.022-1.132.065-1.7.063-3.7-.006-3.712-.014-5.033,3.387-2.353,6.058-1.832,12.036.453,17.993.441,1.148,1.229,1.157,2.189,1.156q10.226-.011,20.45.02a5.623,5.623,0,0,1,2.516.293c-.689.922-1.716.9-2.7.91-6.371.039-12.743,0-19.114-.005a3.481,3.481,0,0,1-2.563-.8l-.866.392c-1.654-.517-3.347-.088-5.019-.2a22.177,22.177,0,0,1-5.768-.927,3.147,3.147,0,0,1-1.354-2.523c-1.186-6.888-1-13.645,2.036-20.112.5-.6.49-1.6,1.432-1.855,1.938.735,3.97.139,5.7.372-1.581-.361-3.565.6-5.3-.623-.241-1.123-.032-1.911,1.36-1.818,3.151.22,6.326.06,9.458.589,1.115.85.047,1.471-.309,2.047-.573.928-.354,1.194.654,1.278,1.159.1,2.381-.339,3.475.367",
    transform: "translate(-97.583 -156.515)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27984",
    "data-name": "Path 27984",
    d: "M148.105,271.116c-.866.271-1.078,1.005-1.255,1.763a1.36,1.36,0,0,1-.736.305c-3.594.4-7.191.929-10.743-.28.564-1.664.118-2.247-1.776-2.185-4.069.135-8.148,0-12.221-.031a3.161,3.161,0,0,1,1.858-.251q10.382-.054,20.765-.084a8.934,8.934,0,0,1,4.107.762",
    transform: "translate(-69.596 -155.494)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27986",
    "data-name": "Path 27986",
    d: "M202.246,336.257l24.376-.1,13.411.5c-.214.926-.048,1.951-.727,2.753a6.079,6.079,0,0,1-3.513.576,72.767,72.767,0,0,0-9.992-.026c-3.324-.219-6.688-.077-9.946-.982a6.692,6.692,0,0,0-4.2-1.033c-3.143.07-6.3-.278-9.422.376.536-.684.051-1.375.017-2.063",
    transform: "translate(-115.958 -193.339)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27987",
    "data-name": "Path 27987",
    d: "M268.771,326.463c-.478-.57-1.145-.476-1.775-.49-5.314-.12-10.618-.6-15.94-.416a1.369,1.369,0,0,1-.213,0c-.667-.08-1.829.22-1.8-.588.037-1.029,1.239-.637,1.934-.62,1.766.043,3.528.289,5.293.319,3.833.064,7.668.059,11.5.047a8.681,8.681,0,0,1,3.131.493l-2.133,1.256",
    transform: "translate(-142.801 -186.498)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27988",
    "data-name": "Path 27988",
    d: "M289.713,351.1c-2.545-.261-2.674-2.688-3.808-4.215-.339-.51-.1-.947.174-1.38a.961.961,0,0,1,1.063-.357c1.732.376,2.553,1.962,3.649,3.044.98.967-1.036,1.778-1.078,2.909",
    transform: "translate(-163.842 -198.483)",
    fill: "#4a0f02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27989",
    "data-name": "Path 27989",
    d: "M270.786,344.131l-.828.461c-.384.594-.924,1.074-1.267,1.7-.935.484-1.063,1.767-2.123,2.127-.646-1.084.284-2.637-.954-3.5-1.165-.81-2.5.162-3.7-.131-1.586-.385-3.55.406-4.7-1.419,4.541-.035,9.083-.137,13.62.161-.016.2-.032.4-.048.6",
    transform: "translate(-147.486 -197.463)",
    fill: "#9f1b15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27990",
    "data-name": "Path 27990",
    d: "M307.115,323.609a2.965,2.965,0,0,1,1.232-1.379,18.161,18.161,0,0,0,1.664,1.5c1.175.831,1.665,1.79.871,3.135a8.139,8.139,0,0,1-3.768-3.255",
    transform: "translate(-176.099 -185.33)",
    fill: "#4d1205"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27993",
    "data-name": "Path 27993",
    d: "M376.68,388.77h-8.264c0-.064,0-.128,0-.191h8.264c0,.064,0,.127,0,.191",
    transform: "translate(-211.249 -223.491)",
    fill: "#ae100f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27994",
    "data-name": "Path 27994",
    d: "M112.5,278.941c.417-.34.372-.835.435-1.292.268-.093-.108-.1.17-.12a71.679,71.679,0,0,1,15.566.1q.019.255.039.51a2.616,2.616,0,0,1,.064,2.625c-1.834,5.51-1.694,11.08-.672,16.7.234,1.287.7,2.625-.058,3.922a2.239,2.239,0,0,1-1.914.689c-3.458.017-6.916-.031-10.375.025a3.254,3.254,0,0,1-1.961-.679,27.783,27.783,0,0,1-2.441-14.784c.266-2.579.757-5.135,1.146-7.7",
    transform: "translate(-63.757 -159.405)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27995",
    "data-name": "Path 27995",
    d: "M148.431,301.325c-.436-3.058-.951-6.108-1.289-9.177-.521-4.729.831-9.2,2.113-13.671l.44-.438c3.139-.533,6.3-.19,9.449-.192.748,0,1.606.294,1.206,1.437a33.2,33.2,0,0,0-1.716,21.3,9.509,9.509,0,0,0,.44,1.179q.2.155.125.3c-.05.091-.1.137-.148.137l-.047.038a38.676,38.676,0,0,1-6.55.159,5.169,5.169,0,0,0-3.016.786.894.894,0,0,1-.65-.011c-.691-.505-.195-1.239-.357-1.846",
    transform: "translate(-84.305 -159.742)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27996",
    "data-name": "Path 27996",
    d: "M163.935,278.488c-.3-1.211-1.3-.81-2.075-.867-2.856-.209-5.749.394-8.581-.378l.386-.885,11.156.047a.3.3,0,0,1-.042.409l-.845,1.674",
    transform: "translate(-87.89 -158.947)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27997",
    "data-name": "Path 27997",
    d: "M130.86,276.63l-15.736.019q-.054-.431-.109-.862.083-.185.163-.371c4.5.811,9.051.172,13.571.4.758.039,1.794-.442,2.111.811",
    transform: "translate(-65.949 -158.405)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28000",
    "data-name": "Path 28000",
    d: "M94.713,43.109a1.053,1.053,0,0,1-.339-.119c.679-.658,1.351-1.656,2.067-.034-.531.558-1.13.352-1.728.153",
    transform: "translate(-54.114 -24.201)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28001",
    "data-name": "Path 28001",
    d: "M95.168,44.3l1.728-.152.447.15c-.438.608-1.123.314-1.688.457l-.487-.455",
    transform: "translate(-54.569 -25.391)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28003",
    "data-name": "Path 28003",
    d: "M292.688,37.76c-.513-.028-.988-.147-1.038-.758a.418.418,0,0,1,.559-.423c.669.163.456.732.477,1.184l0,0",
    transform: "translate(-167.231 -21.029)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28004",
    "data-name": "Path 28004",
    d: "M294.942,28.619c.3.012.549.136.537.454a.449.449,0,0,1-.538.449.637.637,0,0,1-.411-.373c-.1-.307.093-.492.412-.531",
    transform: "translate(-168.869 -16.46)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28005",
    "data-name": "Path 28005",
    d: "M131.377,333.253c.459.5.3,1.141.383,1.727a59.752,59.752,0,0,1-11.092.01c-.832.392-2.1-.509-2.6.869q-.392-1.083-.782-2.168c4.033.008,8.067.021,12.1.019.691,0,1.435.154,1.992-.457",
    transform: "translate(-67.252 -191.67)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28006",
    "data-name": "Path 28006",
    d: "M94.62,332.8l-.391-.438c.138-1.036.75-.636,1.3-.425.9-1.895,2.539-1.937,4.233-1.566.878.193,1.755.649,1.347,1.881.05.743.521,1.379-1.039,1.365a13.2,13.2,0,0,1-5.449-.819",
    transform: "translate(-54.031 -189.909)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28007",
    "data-name": "Path 28007",
    d: "M93.526,310.295a.688.688,0,0,0,.4,1.026c.575.255.953-.049,1.24-.5a2.757,2.757,0,0,1,2.8-1.546,1.86,1.86,0,0,1,1.725,1.621,1.388,1.388,0,0,1-.842,1.56,1.161,1.161,0,0,1-.8.078c-.342-.11-.322-.458-.132-.687.424-.513.984-1.067.01-1.479-.822-.348-1.261.372-1.72.913-1.328,1.566-2.528,1.672-3.639.368a1.569,1.569,0,0,1-.378-1.567c.152-.5.416-.946,1.035-.859.86.122.523.625.3,1.074",
    transform: "translate(-52.822 -177.842)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28008",
    "data-name": "Path 28008",
    d: "M94.526,286.381l.79.157c2.441,1.631-1.19.675-.42,1.833a8.647,8.647,0,0,0,4.081.384c.484-1.027-1.152-.756-.864-1.725,1.105-.187,2.2-.1,2.371,1.235.2,1.555-1.078,1.561-2.168,1.546a22.927,22.927,0,0,1-2.961-.178c-.825-.119-1.77-.26-2.039-1.244-.278-1.017.5-1.517,1.208-2.008",
    transform: "translate(-53.475 -164.712)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28009",
    "data-name": "Path 28009",
    d: "M97.929,280.558c-.816-.63-2.535.189-2.616-1.618.124-.4.266-.786.367-1.187.091-.359.224-.745.648-.63s.261.591.333.918c.227.156.49.475.708.382,1.347-.574,2.635-.091,3.94.135a.727.727,0,0,1,1.156,0c-.03,1.787-.892,2.459-2.665,2.069a9.98,9.98,0,0,0-1.87-.065",
    transform: "translate(-54.652 -159.375)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28010",
    "data-name": "Path 28010",
    d: "M102,330.888a2.686,2.686,0,0,0-4.646-.365c-.308.368-.617.142-.934.049-.125-.4-.273-.795-.367-1.2-.1-.457-.5-.968-.086-1.383.537-.539.8.334,1.238.356,1.119.057,2.241.053,3.358.134a2.5,2.5,0,0,1,2.452,1.67c.278.9.051,1.484-1.016.741",
    transform: "translate(-54.92 -188.541)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28011",
    "data-name": "Path 28011",
    d: "M101.362,320.133c1.1.124,2.339.36,2.206,1.718s-1.454,1.333-2.526,1.318a3.042,3.042,0,0,1-2.656-.828c1.237-1.01,2.863.64,3.935-.644-.375-.871-1.415-.478-1.978-1,.117-.381.442-.455.774-.52l.244-.048",
    transform: "translate(-56.414 -184.124)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28012",
    "data-name": "Path 28012",
    d: "M92.911,303.306c-1.6-.169-.543-1.377-.788-2.072-.1-.285-.025-.845.428-.752.321.066.559.534.834.822.7.4,1.531-.027,2.243.325,1.168.1,2.428-.269,3.746.7-1.473.594-2.681.216-3.872.157-.995-.137-2.125-.7-2.59.822",
    transform: "translate(-52.755 -172.816)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28013",
    "data-name": "Path 28013",
    d: "M96.936,296.8a6.6,6.6,0,0,1,4.859.219c-1.622.313-3.24.6-4.859-.219",
    transform: "translate(-55.583 -170.503)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28014",
    "data-name": "Path 28014",
    d: "M96.444,320.017a3.444,3.444,0,0,1-2.826-.631,8.461,8.461,0,0,1,5.01.137l-.139.156c-.641.356-1.42-.115-2.045.338",
    transform: "translate(-53.68 -183.514)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28015",
    "data-name": "Path 28015",
    d: "M94.131,305.5c.343-1.4.526-1.459,2.59-.823-.9.145-1.98-.243-2.59.823",
    transform: "translate(-53.975 -175.012)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28016",
    "data-name": "Path 28016",
    d: "M97.484,302.756c-.77.041-1.569.286-2.243-.325a4.822,4.822,0,0,1,2.243.325",
    transform: "translate(-54.611 -173.943)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28017",
    "data-name": "Path 28017",
    d: "M100.243,320.75c.6-.613,1.344-.347,2.046-.339l-.88.412-1.166-.073",
    transform: "translate(-57.479 -184.247)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28018",
    "data-name": "Path 28018",
    d: "M151.891,335.593c.1-.449-.079-1.15.6-1.173,3.075-.1,6.168-.645,9.213.27.2,1.133-.537,1.028-1.274,1-1.742-.075-3.489-.066-5.227-.194a2.8,2.8,0,0,0-2.853,1.3l-.416-.43a.514.514,0,0,1-.048-.765",
    transform: "translate(-87.01 -192.195)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28019",
    "data-name": "Path 28019",
    d: "M136.679,337.405q.024.382.048.765c-2.846-.893-5.77-.2-8.648-.433-.961-.078-2,.327-2.865-.41l11.092-.01q.185.048.372.088",
    transform: "translate(-71.798 -194.007)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28020",
    "data-name": "Path 28020",
    d: "M175.212,334.719c.007-.144.015-.288.022-.432,3.2-.076,6.377.977,9.595.163.936-.237,1.015.457,1.059,1.122-2.255.858-4.583.373-6.874.3a7.563,7.563,0,0,0-3.011.172l-.791-1.324",
    transform: "translate(-100.466 -192.263)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28021",
    "data-name": "Path 28021",
    d: "M244,342.9a16.956,16.956,0,0,0,5.78.715c1.154-.1,2.5-.92,3.356.145a3.264,3.264,0,0,1,.22,4.187q-4.529,5.039-9.055,10.081c-2.677,3-5.331,6.022-8,9.034-.456.151-.739.275-.662-.493.134-1.337,1.09-2.273,1.482-3.48,1.523-4.677,1.129-9.3-.212-13.927a26.821,26.821,0,0,1-1.216-5.084c-.064-.72-1.555-.374-1.529-1.449A57.2,57.2,0,0,1,244,342.9",
    transform: "translate(-134.271 -196.991)",
    fill: "#b61b15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28022",
    "data-name": "Path 28022",
    d: "M284.1,348.006c-.11-.96.52-1.372,1.267-1.7l-.409,1.277-.857.421",
    transform: "translate(-162.897 -199.179)",
    fill: "#81170a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28023",
    "data-name": "Path 28023",
    d: "M103.019,279.1c-.068.828-.764,1.694-1.22.9-.809-1.4-1.172-.574-1.994-.212-.8.352-1.792.179-1.434-1.209,1.61-.364,3.275-1.224,4.648.517",
    transform: "translate(-56.363 -159.92)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28024",
    "data-name": "Path 28024",
    d: "M251,292.851c-.347.818-.83.68-1.214.682q-13.83.08-27.633-.778c-2.336-.148-4.686-.057-7.03-.1-.468-.009-1.159.031-1.1-.648.052-.633.732-.571,1.211-.546,10.27.544,20.549.717,30.83.851,1.606.021,3.208.342,4.939.539",
    transform: "translate(-122.717 -167.625)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28025",
    "data-name": "Path 28025",
    d: "M247.4,315.628c-12.16.927-24.323-.29-36.485-.119q0-.292,0-.584h36.435q.027.352.054.7",
    transform: "translate(-120.937 -181.128)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28026",
    "data-name": "Path 28026",
    d: "M233.977,306.736c8.87-.3,17.743-.7,26.591.586-8.869.331-17.736.547-26.591-.586",
    transform: "translate(-134.162 -176.245)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28027",
    "data-name": "Path 28027",
    d: "M180.237,276.779a3.466,3.466,0,0,0,.042-.409c.107-.027.215-.051.323-.073,2.123.008,4.245.008,6.368.029.479,0,1.133-.061,1.162.6.029.681-.623.65-1.1.653-1.91.014-3.821,0-5.731,0a.926.926,0,0,1-1.059-.8",
    transform: "translate(-103.348 -158.912)",
    fill: "#e6e7eb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibra);
export default __webpack_public_path__ + "static/media/Libra.030e1340a4067adc681afaa99b5f303f.svg";
export { ForwardRef as ReactComponent };